/* eslint-disable react-hooks/rules-of-hooks */
import { useDispatch, useSelector } from 'react-redux';
import { companyWorkspacesSelector, isLoadingWorkspacesSelector, userRoleSelector } from '../redux/selectors';
import { useEffect } from 'react';
import { TCompanyWorkspace } from 'src/interfaces/workspacesReduxShapes';
import { getCompanyWorkspaces } from 'src/redux/actions/workspacesActions';
import { ACCOUNT_ROLES } from 'src/constants/globalConstants';

export const getCompanyWorkspacesHook = (): {
  companyWorkspaces: TCompanyWorkspace[];
  isLoading: boolean;
} => {
  const dispatch = useDispatch();
  const companyWorkspaces = useSelector(companyWorkspacesSelector);
  const isLoading = useSelector(isLoadingWorkspacesSelector);
  const userRole = useSelector(userRoleSelector);

  useEffect(() => {
    if (userRole !== ACCOUNT_ROLES.COMPANY) return;

    dispatch(getCompanyWorkspaces());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userRole]);

  return { companyWorkspaces, isLoading };
};
